import { createContext, useContext } from 'react'

export interface MediaValues {
  isMobileView: boolean
  isDesktopView: boolean
  isKeyboardOpen?: boolean
}

export const MediaContext = createContext<MediaValues>({
  isMobileView: true,
  isDesktopView: false,
})

export const useMediaContext = () => useContext(MediaContext)
